module.exports = __webpack_public_path__ + "static/img/top.c21e0d2a.png";